import { useTranslation } from "react-i18next";
import Header from "../../reusable/Header";
import { Avatar, Button } from "@nextui-org/react";
import { CameraIcon2 } from "../../icons/CameraIcon2";
import { RecordIcon2 } from "../../icons/RecordIcon2";
import { DoneIcon2 } from "../../icons/DoneIcon2";
import PoweredBy from "../../reusable/PoweredBy";

const VIDEO_STEPS = [
    {
        icon: <RecordIcon2 />,
        key: "record",
    },
    {
        icon: <Avatar className="h-8 w-8" isBordered color="primary" src="/liveness.webp" />,
        key: "turnHead",
    },
    {
        icon: <DoneIcon2 />,
        key: "autoSubmit",
    },
];

const PHOTO_STEPS = [
    {
        icon: "🎯",
        key: "center",
    },
    {
        icon: "💡",
        key: "lighting",
    },
    {
        icon: "😄",
        key: "smile",
    },
];

const LivenessHelp = ({ openCamera, biometricType }) => {
    const { t } = useTranslation();
    const isVideo = biometricType === "SELFIE_VIDEO";
    const steps = isVideo ? VIDEO_STEPS : PHOTO_STEPS;
    const stepsNamespace = isVideo ? "videoSteps" : "photoSteps";

    return (
        <div className="flex flex-col h-full">
            <Header />
            <div className="flex flex-col p-5 h-full">

                {/* Heading */}
                <div className="flex flex-col items-center text-center gap-1">
                    <div className="heading text-xl">{t("liveness.help.heading")}</div>
                    <div className="desc text-sm" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{t("liveness.help.subheading")}</div>
                </div>

                {/* Steps */}
                {/* mt-8 is a plain spacing placeholder — a hero illustration
                    (matching DocUploadGizmo's spot on the document-upload/
                    proof-of-residence screens) would go here once separate
                    photo/video assets exist. */}
                <div className="flex flex-col gap-3 mt-8">
                    {steps.map((step, i) => (
                        <div key={step.key} className="flex flex-row items-center gap-4 p-4 rounded-xl background">
                            <div className="flex-shrink-0 w-8 flex items-center justify-center text-2xl">
                                {step.icon}
                            </div>
                            <div className="flex flex-col">
                                <div
                                    className="text-xs font-semibold uppercase tracking-widest mb-0.5"
                                    style={{color: "var(--urtentic-sdk-body, #737373)"}}
                                >
                                    {t("liveness.help.step", { step: i + 1 })}
                                </div>
                                <div
                                    className="text-sm font-medium"
                                    style={{color: "var(--urtentic-sdk-body, #737373)"}}
                                >
                                    {t(`liveness.help.${stepsNamespace}.${step.key}`)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="flex flex-col gap-2 mt-auto">
                    <Button
                        radius="sm"
                        startContent={<CameraIcon2 />}
                        color="primary"
                        size="lg"
                        fullWidth
                        onClick={() => openCamera(true)}
                    >
                        {t("liveness.help.openCamera")}
                    </Button>
                    <div className="flex justify-center">
                        <PoweredBy />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default LivenessHelp;
